export var BUNDLE_INFO_VARIABLE = 'info';
export function getInfoHostName(host) {
    /**
     * We cant use `_` symbol, since it is used to split the host batch
     */
    return "info-" + host;
}
export function getInfoHostConfig(host, getComponentName) {
    var _a;
    return _a = {},
        _a[getInfoHostName(host)] = {
            entries: {
                generateParts: false,
                generateComponents: false,
                generateHost: true,
            },
            getComponentName: getComponentName,
            conventions: [
                {
                    part: 'info',
                    path: "{,*/}%ComponentName%/%ComponentName%.info.ts",
                },
            ],
        },
        _a;
}
//# sourceMappingURL=infoConventions.js.map